export const VOUCHER_STATUS_CATEGORIES = {
  ACTIVE: 'active',
  CLOSED: 'closed',
};

export const VOUCHER_STATUS_KEYS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  PAID: 'paid',
};

// API returns - Active, Accepted, Rejected, Paid (Accounts has paid out an approved claim)
export const API_VOUCHER_STATUS_KEYS = {
  Active: 'pending',
  Accepted: 'approved',
  Rejected: 'rejected',
  Paid: 'paid',
};

export const EMPTY_VOUCHERS_BY_STATUS = {
  pending: [],
  closed: [],
};

export const VOUCHER_PRIMARY_VIEWS = {
  ACTIVE: 'active',
  CLOSED: 'closed',
};

export const VOUCHER_CLOSED_STATUSES = {
  APPROVED: 'approved',
  REJECTED: 'rejected',
  PAID: 'paid',
};

export const PRIMARY_VIEW_OPTIONS = [
  { label: 'Active', value: VOUCHER_PRIMARY_VIEWS.ACTIVE },
  { label: 'Closed', value: VOUCHER_PRIMARY_VIEWS.CLOSED },
];

export const CLOSED_STATUS_OPTIONS = [
  { label: 'Approved', value: VOUCHER_CLOSED_STATUSES.APPROVED },
  { label: 'Rejected', value: VOUCHER_CLOSED_STATUSES.REJECTED },
  { label: 'Paid', value: VOUCHER_CLOSED_STATUSES.PAID },
];

export const EMPTY_TABLE_MESSAGES = {
  [VOUCHER_PRIMARY_VIEWS.ACTIVE]: 'No active voucher requests found',
  [VOUCHER_PRIMARY_VIEWS.CLOSED]: 'No closed voucher requests found',
  [VOUCHER_CLOSED_STATUSES.APPROVED]: 'No approved vouchers found',
  [VOUCHER_CLOSED_STATUSES.REJECTED]: 'No rejected vouchers found',
  [VOUCHER_CLOSED_STATUSES.PAID]: 'No paid vouchers found',
};

export const VOUCHER_STATUS = {
  [VOUCHER_STATUS_KEYS.PENDING]: {
    key: VOUCHER_STATUS_KEYS.PENDING,
    label: 'Pending',
    color: 'warning',
    category: VOUCHER_STATUS_CATEGORIES.ACTIVE,
  },
  [VOUCHER_STATUS_KEYS.APPROVED]: {
    key: VOUCHER_STATUS_KEYS.APPROVED,
    label: 'Approved',
    color: 'success',
    category: VOUCHER_STATUS_CATEGORIES.CLOSED,
  },
  [VOUCHER_STATUS_KEYS.REJECTED]: {
    key: VOUCHER_STATUS_KEYS.REJECTED,
    label: 'Rejected',
    color: 'error',
    category: VOUCHER_STATUS_CATEGORIES.CLOSED,
  },
  [VOUCHER_STATUS_KEYS.PAID]: {
    key: VOUCHER_STATUS_KEYS.PAID,
    label: 'Paid',
    color: 'info',
    category: VOUCHER_STATUS_CATEGORIES.CLOSED,
  },
};

export const EXPENSE_TYPES = {
  OFFICE_SUPPLIES: 'Office supplies',
  GIFT_VOUCHER: 'Gift voucher',
  SITE_VISIT: 'Site visit',
  HOTEL_EXPENSES: 'Hotel expenses',
  TRAVEL_EXPENSES: 'Travel expenses',
  TRAINING_AND_EDUCATION_EXPENSE: 'Training and education expense',
  DUES_AND_SUBSCRIPTION_EXPENSE: 'Dues and subscription expense',
  UTILITIES: 'Utilities',
  OTHER: 'Other',
};

export const EXPENSE_TYPE_OPTIONS = Object.keys(EXPENSE_TYPES).map((key) => ({
  value: EXPENSE_TYPES[key],
  label: EXPENSE_TYPES[key],
}));

export const VOUCHER_ACTION_MODES = {
  IDLE: 'idle',
  APPROVE: 'approve',
  REJECT: 'reject',
};

